/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingCouponCode
 */
export interface BillingCouponCode {
    /**
     * 
     * @type {string}
     * @memberof BillingCouponCode
     */
    code: string;
}

/**
 * Check if a given object implements the BillingCouponCode interface.
 */
export function instanceOfBillingCouponCode(value: object): value is BillingCouponCode {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function BillingCouponCodeFromJSON(json: any): BillingCouponCode {
    return BillingCouponCodeFromJSONTyped(json, false);
}

export function BillingCouponCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingCouponCode {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

  export function BillingCouponCodeToJSON(json: any): BillingCouponCode {
      return BillingCouponCodeToJSONTyped(json, false);
  }

  export function BillingCouponCodeToJSONTyped(value?: BillingCouponCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

